const routes = {
  adaptiveLearningAssessment: 'adaptive-learning',
  root: '/assessment-player',
}

export default routes
